export function openSalesIQChat() {
  if (typeof window === 'undefined') return;

  const showChat = () => {
    try {
      if (window.$zoho?.salesiq?.floatwindow?.visible) {
        window.$zoho.salesiq.floatwindow.visible('show');
        return true;
      }
    } catch {
      /* ignore */
    }
    return false;
  };

  if (showChat()) return;

  const priorReady = window.$zoho?.salesiq?.ready;
  window.$zoho = window.$zoho || {};
  window.$zoho.salesiq = window.$zoho.salesiq || {};
  window.$zoho.salesiq.ready = function ready() {
    if (typeof priorReady === 'function') priorReady();
    showChat();
  };
}
